import styled from "styled-components";

export const Svg = styled.svg`
  position: absolute;
  width: 400px;
  height: 400px;
  z-index: 1000;
`;

interface HandleProps {
  cursor: string;
  isClicked?: boolean;
}

export const Handle = styled.rect<HandleProps>`
  width: ${(props) => (props.isClicked ? "100%" : "10px")};
  height: ${(props) => (props.isClicked ? "100%" : "10px")};
  cursor: ${(props) => props.cursor};
  fill: transparent;
  rx: 2px;
  @media (max-width: 768px) {
    width: ${(props) => (props.isClicked ? "100%" : "20px")};
    height: ${(props) => (props.isClicked ? "100%" : "20px")};
  }
`;
interface HandleProps {
  isSignature?: string;
}
export const HandleFixed = styled.rect<HandleProps>`
  width: 10px;
  height: 10px;
  fill: ${(props) => (props.isSignature === "signature" ? "#ccc" : "#2c2c2c")};
  rx: 2px;
  pointer-events: none;
`;

export const ContainerRect = styled.g`
  cursor: pointer;
  fill: #355b94;
  &:hover {
    fill: #32568C;
  }
`;
export const Input = styled.input`
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  border: none;
  padding: 0;
  margin: 0;
  outline: none;
  background: none;
  color: #000000;
  font-size: 12px;
  &::placeholder {
    padding: 0;
    margin: 0;
  }
`;
